import { render, staticRenderFns } from "./ManagerForecast.vue?vue&type=template&id=98568992"
import script from "./ManagerForecast.vue?vue&type=script&lang=js"
export * from "./ManagerForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports